<template>
  <AppHeader>Create Transaction</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="p-3 text-gray-600 bg-white shadow rounded-2xl">
      <div class="px-2 py-1 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Customer</p>
        <CustomerSearch v-model="form.customer_id" :customers="customers" autofocus></CustomerSearch>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.customer_id">{{ errors.customer_id }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Type</p>
        <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.type" name="type">
          <option value="debit">Debit</option>
          <option value="credit">Credit</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.type">{{ errors.type }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Amount (₹)</p>
        <input class="w-full text-xl placeholder:text-lg" v-model="form.amount" name="amount" placeholder="Enter Transaction Amount">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.amount">{{ errors.amount }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Purpose</p>
        <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.purpose" name="purpose" required>
          <option value="">-- Select Purpose --</option>
          <option v-for="purpose in purposes[form.type]" :key="purpose" :value="purpose">{{ purpose }}</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.purpose">{{ errors.purpose }}</p>
      </div>

      <div v-if="form.purpose" class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Detail</p>

        <!-- DEBIT -->
        <div v-if="form.type == 'debit' && form.purpose == 'Debited for Milk Delivery'" class="flex justify-between">
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[0]">
            <option value="">-- TYPE --</option>
            <option v-for="product in productsMilk" :key="product.id" :value="product.name + ' (' + product.quantity + ')'">{{ product.quantity }}</option>
          </select>
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[1]">
            <option value="">-- QTY --</option>
            <option value="x 1">1</option>
            <option value="x 2">2</option>
            <option value="x 3">3</option>
            <option value="x 4">4</option>
            <option value="x 5">5</option>
          </select>
          <input class="w-full text-xl placeholder:text-lg" v-model="form.detail[2]" :min="minDate" :max="maxDate" type="date" placeholder="Enter Delivery Date">
        </div>

        <div v-if="form.type == 'debit' && form.purpose == 'Debited for Milk Delivery (Multiday)'" class="flex justify-between">
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[0]">
            <option value="">-- TYPE --</option>
            <option v-for="product in productsMilk" :key="product.id" :value="product.name + ' (' + product.quantity + ')'">{{ product.quantity }}</option>
          </select>
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[1]">
            <option value="">-- QTY --</option>
            <option value="x 1">1</option>
            <option value="x 2">2</option>
            <option value="x 3">3</option>
            <option value="x 4">4</option>
            <option value="x 5">5</option>
            <option value="x 6">6</option>
            <option value="x 7">7</option>
            <option value="x 8">8</option>
            <option value="x 9">9</option>
            <option value="x 10">10</option>
          </select>
          <input class="w-full text-xl placeholder:text-lg" v-model="form.detail[2]" placeholder="Enter Delivery Dates">
        </div>

        <div v-if="form.type == 'debit' && form.purpose == 'Manual deduction by Dealer'" class="flex justify-between">
          <input class="w-full text-xl placeholder:text-lg" v-model="form.detail[0]" placeholder="Enter Debit Purpose fully">
        </div>

        <div v-if="form.type == 'debit' && form.purpose == 'Delivery Fee for the month of'" class="flex justify-between">
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[0]">
            <option value="">-- Select Month --</option>
            <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
          </select>
        </div>

        <div v-if="form.type == 'debit' && form.purpose == 'Debited for Order Delivery'" class="flex justify-between">
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[0]">
            <option value="">-- Product --</option>
            <option v-for="product in productsOthers" :key="product.id" :value="product.name + ' (' + product.quantity + ')'">{{ product.name }} ({{ product.quantity }})</option>
          </select>
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[1]">
            <option value="">-- QTY --</option>
            <option value="x 1">1</option>
            <option value="x 2">2</option>
            <option value="x 3">3</option>
            <option value="x 4">4</option>
            <option value="x 5">5</option>
          </select>
          <input class="w-full text-xl placeholder:text-lg" v-model="form.detail[2]" placeholder="Order ID">
        </div>

        <div v-if="form.type == 'debit' && form.purpose == 'Delivery Fee for Order'" class="flex justify-between">
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[0]">
            <option value="">-- Product --</option>
            <option v-for="product in productsOthers" :key="product.id" :value="product.name + ' (' + product.quantity + ')'">{{ product.name }} ({{ product.quantity }})</option>
          </select>
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[1]">
            <option value="">-- QTY --</option>
            <option value="x 1">1</option>
            <option value="x 2">2</option>
            <option value="x 3">3</option>
            <option value="x 4">4</option>
            <option value="x 5">5</option>
          </select>
          <input class="w-full text-xl placeholder:text-lg" v-model="form.detail[2]" placeholder="Order ID">
        </div>

        <!-- CREDIT -->
        <div v-if="form.type == 'credit' && form.purpose == 'Manual Wallet Recharge'" class="flex justify-between">
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[0]">
            <option value="">-- Select Payment Method --</option>
            <option v-for="opt in manualRechargeOptions" :key="opt" :value="opt">{{ opt }}</option>
          </select>
        </div>

        <div v-if="form.type == 'credit' && form.purpose == 'Refund for Account Closure'" class="flex justify-between">
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[0]">
            <option value="">-- Select Closure Reason --</option>
            <option v-for="opt in accountClosureOptions" :key="opt" :value="opt">{{ opt }}</option>
          </select>
        </div>

        <div v-if="form.type == 'credit' && form.purpose == 'Refund for a Wrong Debit'" class="flex justify-between">
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[0]">
            <option value="">-- TYPE --</option>
            <option v-for="product in productsMilk" :key="product.id" :value="product.name + ' (' + product.quantity + ')'">{{ product.quantity }}</option>
          </select>
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[1]">
            <option value="">-- QTY --</option>
            <option value="x 1">1</option>
            <option value="x 2">2</option>
            <option value="x 3">3</option>
            <option value="x 4">4</option>
            <option value="x 5">5</option>
          </select>
          <input class="w-full text-xl placeholder:text-lg" v-model="form.detail[2]" :min="minDate" :max="maxDate" type="date" placeholder="Enter Delivery Date">
        </div>

        <div v-if="form.type == 'credit' && form.purpose == 'Refund for a Wrong Debit (Multiday)'" class="flex justify-between">
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[0]">
            <option value="">-- TYPE --</option>
            <option v-for="product in productsMilk" :key="product.id" :value="product.name + ' (' + product.quantity + ')'">{{ product.quantity }}</option>
          </select>
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[1]">
            <option value="">-- QTY --</option>
            <option value="x 1">1</option>
            <option value="x 2">2</option>
            <option value="x 3">3</option>
            <option value="x 4">4</option>
            <option value="x 5">5</option>
            <option value="x 6">6</option>
            <option value="x 7">7</option>
            <option value="x 8">8</option>
            <option value="x 9">9</option>
            <option value="x 10">10</option>
          </select>
          <input class="w-full text-xl placeholder:text-lg" v-model="form.detail[2]" placeholder="Enter Delivery Dates">
        </div>

        <div v-if="form.type == 'credit' && form.purpose == 'Refund for Milk Spoilage'" class="flex justify-between">
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[0]">
            <option value="">-- TYPE --</option>
            <option v-for="product in productsMilk" :key="product.id" :value="product.name + ' (' + product.quantity + ')'">{{ product.quantity }}</option>
          </select>
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[1]">
            <option value="">-- QTY --</option>
            <option value="x 1">1</option>
            <option value="x 2">2</option>
            <option value="x 3">3</option>
            <option value="x 4">4</option>
            <option value="x 5">5</option>
          </select>
          <input class="w-full text-xl placeholder:text-lg" v-model="form.detail[2]" :min="minDate" :max="maxDate" type="date" placeholder="Enter Delivery Date">
        </div>

        <div v-if="form.type == 'credit' && form.purpose == 'Refund for Bottle breakage'" class="flex justify-between">
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[0]">
            <option value="">-- TYPE --</option>
            <option v-for="product in productsMilk" :key="product.id" :value="product.name + ' (' + product.quantity + ')'">{{ product.quantity }}</option>
          </select>
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[1]">
            <option value="">-- QTY --</option>
            <option value="x 1">1</option>
            <option value="x 2">2</option>
            <option value="x 3">3</option>
            <option value="x 4">4</option>
            <option value="x 5">5</option>
          </select>
          <input class="w-full text-xl placeholder:text-lg" v-model="form.detail[2]" :min="minDate" :max="maxDate" type="date" placeholder="Enter Delivery Date">
        </div>

        <div v-if="form.type == 'credit' && form.purpose == 'Refund for Product Purchase'" class="flex justify-between">
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[0]">
            <option value="">-- Product --</option>
            <option v-for="product in productsOthers" :key="product.id" :value="product.id">{{ product.name }} ({{ product.quantity }})</option>
          </select>
          <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.detail[1]">
            <option value="">-- QTY --</option>
            <option value="x 1">1</option>
            <option value="x 2">2</option>
            <option value="x 3">3</option>
            <option value="x 4">4</option>
            <option value="x 5">5</option>
          </select>
          <input class="w-full text-xl placeholder:text-lg" v-model="form.detail[2]" placeholder="Order ID">
        </div>

        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.detail">{{ errors.detail }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Notes</p>
        <textarea class="w-full text-xl placeholder:text-lg" v-model="form.notes" name="notes" placeholder="Enter Notes"></textarea>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.notes">{{ errors.notes }}</p>
      </div>
    </div>

    <div class="mt-5 text-center">
      <button class="px-3 py-2 text-sm leading-none text-gray-600 uppercase rounded-full bg-slate-300" @click="createTransaction">Create Tranasction</button>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import dayjs from 'dayjs';
import formMixin from '@/utils/mixins/form';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import CustomerSearch from '@/components/common/CustomerSearch.vue';

export default {
  name: 'CreateTransaction',
  mixins: [ mixin, formMixin ],
  components: { AppHeader, Loading, CustomerSearch },
  data() {
    return {
      state: 'loading',
      balance: null,
      customers: [],
      maxDate: dayjs().format('YYYY-MM-DD'),
      minDate: dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
      purposes: [],
      months: [],
      productsMilk: [],
      productsOthers: [],
      manualRechargeOptions: [],
      accountClosureOptions: [],
      form: { customer_id: '', type: 'debit', purpose: '', detail: ['', '', ''] },
    }
  },

  watch: {
    'form.type'() {
      this.form.purpose = '';
    },

    'form.purpose'() {
      this.form.detail = ['', '', ''];
    },
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'wallet/prepare', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.customers = resp.data.customers;
          this.purposes = resp.data.purposes;
          this.months = resp.data.months;
          this.productsMilk = resp.data.productsMilk;
          this.productsOthers = resp.data.productsOthers;
          this.manualRechargeOptions = resp.data.manualRechargeOptions;
          this.accountClosureOptions = resp.data.accountClosureOptions;
        }
      });
    },

    createTransaction() {
      let rules = {
        customer_id: 'required|numeric',
        type: 'required|notempty',
        amount: 'required|numeric',
        purpose: 'required|notempty',
        // detail: 'required|notempty',
        notes: '',
      };

      if (!this.validateForm(this.form, rules)) return;
      if (this.form.detail[0] == '' || (this.form.detail[1] != '' && this.form.detail[2] == '')) {
        this.errors.detail = 'This feild is required';
        return;
      }

      if (!confirm('Are you sure?')) return;

      let detail = '';
      if (this.form.detail[1] == '') {
        detail = this.form.detail[0];
      } else {
        detail = this.form.detail[0] + ' ' + this.form.detail[1] + ' - (' + this.form.detail[2] + ')';
      }

      let data = { ...this.form };
      data.detail = detail;

      this.state = 'loading';

      this.request('POST', 'wallet/update', data, (resp) => {
        this.state = 'idle';

        alert(resp.message);
        if (resp.success) {
          this.form = { customer_id: this.$route.query.customer_id ? this.$route.query.customer_id : '', type: 'debit', date: (new Date()).toISOString().substr(0, 10), purpose: '', detail: ['', '', '']};
          this.balance = null;
        }
      });
    },
  },

  created() {
    let today = new Date();
    this.form.date = today.toISOString().substr(0, 10);
    if (this.$route.query.customer_id) this.form.customer_id = this.$route.query.customer_id;
    this.getData();
  }
}
</script>
